import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ab43c062&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab43c062')) {
      api.createRecord('ab43c062', component.options)
    } else {
      api.reload('ab43c062', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=ab43c062&", function () {
      api.rerender('ab43c062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Footer.vue"
export default component.exports